define('services/search/search',["rest/search", "model/search/search", "../chain", "../validators", "../converters", "../worldEdge", "../utils"],
    function (search, model, chain, validators, converters, worldEdge, utils) {
        "use strict";

        var TYPES = {
            search: "search",
            poi: "poiSearch",
            category: "categorySearch",
            geometry: "geometrySearch",
            nearby: "nearbySearch",
            lowBandwidth: "s"
        }, fields = {
            key: {validator: validators.string},
            query: {validator: validators.string, required: true},
            typeahead: {validator: validators.bool},
            limit: {validator: validators.limit},
            offset: {validator: validators.offset, name: "ofs"},
            countrySet: {validator: validators.countrySet},
            radius: {validator: validators.positiveInteger},
            boundingBox: {validator: validators.boundingBox, converter: converters.boundingBox},
            center: {converter: converters.point, validator: validators.point},
            type: {validator: validators.string, defaultValue: TYPES.search},
            bestResult: {validator: validators.bool},
            protocol: {validator: validators.protocol},
            baseUrl: {validator: validators.string},
            serviceUrl: {validator: validators.string}
        };

        function addBoundingBoxParameters(data, boundingBox) {
            data.topLeft = [boundingBox.maxLat, boundingBox.minLon];
            data.btmRight = [boundingBox.minLat, boundingBox.maxLon];
            return data;
        }

        function callbackBestResult(bestResult, callback) {
            return function (response) {
                callback(bestResult ? response[0] : response);
            };
        }

        function Search(options) {
            this.options = options;
            this.defaultFields = utils.clone(fields);
            this.fields = {};
        }

        Search.prototype.TYPE = TYPES;
        Search.prototype.model = model;
        Search.prototype.construct = function () {
            var mergedFields = utils.addFields.call(this, this.fields);
            return chain.call(this, mergedFields, this.handleChain, this.options);
        };
        Search.prototype.handleChain = function (data, callback) {
            var bestResult = !!data.bestResult;
            if (bestResult) {
                data.limit = 1;
                data.offset = 0;
            }

            if (data.center) {
                data.center = data.center.split(",");
                data.lat = data.center[0];
                data.lon = data.center[1];
                delete data.center;
            }
            worldEdge(search.search, this.model, data, callbackBestResult(bestResult, callback), addBoundingBoxParameters);
        };

        function searchConstructor(options) {
            return (new Search(options)).construct();
        }

        searchConstructor.prototype.constructor = Search;

        return searchConstructor;
    });
